module.exports = __webpack_public_path__ + "img/so.49c23c23.svg";